import { QuestionAnswer } from 'common/types'
import { JobProps, JobFeedResponse, JobOrderCriteria, JobOrderPriority, IJobFilter } from 'common/types/job.types'
import { useJobsApi } from 'hooks/use-jobs-api/useJobsApi'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useState } from 'react'

export const useJobsFeed = (pageSize: number = 3) => {
  const { getJobsByQuery, getMemberJobs } = useJobsApi()
  const [fetchingJobs, setFetchingJobs] = useState<boolean>(false)
  const [jobs, setJobs] = useState<JobProps[]>([])
  const [lastResponse, setLastResponse] = useState<JobFeedResponse>(null)
  const [filter, setFilter] = useState<IJobFilter>({})
  const [noOfSearchResults, setNoOfSearchResults] = useState(0)
  const { backendUser } = useAuth()

  const questions: QuestionAnswer[] = backendUser?.onboardingQuestions
  const userAreaOfExpertise = questions?.find(ans => ans.question.trim() === "Area of Expertise")
  const userIndustry = questions?.find(ans => ans.question.trim() === "Industry")

  const jobsOrderCriteria: JobOrderCriteria = {
    areaOfExpertise: userAreaOfExpertise?.answer,
    industry: userIndustry?.answer
  }

  const fetchJobs = async (page = 1) => {
    try {
      if (Object.values(filter).every(value => value === undefined || value === "")) {
        let orderPriority: JobOrderPriority = {
          areaOfExpertise: userAreaOfExpertise?.answer,
          industry: userIndustry?.answer
        }
        setFetchingJobs(true)
        const jobsResponse = await getJobsByQuery(page, pageSize, filter, orderPriority)
        if (jobsResponse) {
          setNoOfSearchResults(jobsResponse.data?.length)
          setJobs([...jobsResponse.data])
          setLastResponse(jobsResponse)
        }
        setFetchingJobs(false)
        return 
      }

      setFetchingJobs(true)
      const jobsResponse = await getJobsByQuery(page, pageSize, filter)
      if (jobsResponse) {
        setNoOfSearchResults(jobsResponse.data?.length)
        setJobs([...jobsResponse.data])
        setLastResponse(jobsResponse)
      }
      setFetchingJobs(false)
    } catch (e: any) {
      setFetchingJobs(false)
    }
  }

  const fetchMoreMemberJobs = async () => {
    try {
      const jobsResponse = await getMemberJobs(parseInt(lastResponse.page) + 1, pageSize, jobsOrderCriteria)
      if (jobsResponse) {
        setJobs([...jobs, ...jobsResponse.data])
        setLastResponse(jobsResponse)
      }
    } catch (e: any) {}
  }

  return {
    fetchMoreMemberJobs,
    fetchJobs,
    fetchingJobs,
    lastResponse,
    jobs,
    filter,
    setFilter,
    noOfSearchResults,
  }
}
